module.exports = __webpack_public_path__ + "img/w-profile-qr.b366dc6b.svg";